module.exports = __webpack_public_path__ + "static/no4-6a38b65f179c50ee4e0c37a3360e67ee.png";